module.exports = __webpack_public_path__ + "static/media/logo_header.dade14a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo_header.svg
// module id = 808
// module chunks = 2